<script setup lang="ts">
import { useFetchSimilarKits } from '~/composables/product'
import { GtmItemListId } from '~/composables/useKftGtm/types'

const props = withDefaults(
  defineProps<{
    title: string
    subtitle?: string
    spaciousHeader?: boolean
    titleClass?: string
    isDurationVisible: boolean
    category?: string
    tag?: string
    count?: number
    itemsPerPage?: number
    showItemsOnDesktop?: number
    isMobileSlider?: boolean
    /** Horizontal rail at every breakpoint instead of a grid from `md:` up. */
    isSlider?: boolean
    /** Show "show more" beside the title — see `ProductShowcase.showMoreInTitle`. */
    showMoreInTitle?: boolean
    /** "Show more" reveals capped products — see `ProductShowcase.expandable`. */
    expandable?: boolean
    isDesktopAccordeon?: boolean
    maxRows?: number
    maxProducts?: number
    gtmItemListId?: string
  }>(),
  {
    title: '',
    subtitle: '',
    spaciousHeader: false,
    titleClass: 'section-title',
    isDurationVisible: false,
    category: '',
    tag: '',
    count: 5,
    itemsPerPage: 8,
    showItemsOnDesktop: 4,
    isMobileSlider: false,
    isSlider: false,
    showMoreInTitle: false,
    expandable: false,
    isDesktopAccordeon: false,
    maxRows: undefined,
    maxProducts: undefined,
    gtmItemListId: GtmItemListId.KitsPageKits,
  }
)
const { data: boxesEvents } = await useFetchSimilarKits(
  props.category,
  props.itemsPerPage
)
</script>
<template>
  <div v-show="boxesEvents?.data?.length">
    <ProductShowcase
      data-test-id="kit-events-section"
      :products="boxesEvents?.data"
      image-loading="eager"
      :title-h-class="titleClass"
      :title="title"
      :subtitle="subtitle"
      :spacious-header="spaciousHeader"
      :is-duration-visible="false"
      :is-mobile-slider="isMobileSlider"
      :is-slider="isSlider"
      :show-more-in-title="showMoreInTitle"
      :expandable="expandable"
      :is-desktop-accordeon="isDesktopAccordeon"
      :show-items-on-desktop="showItemsOnDesktop"
      :max-rows="maxRows"
      :max-products="maxProducts"
      :gtm-item-list-id="gtmItemListId"
      algolia-insights-label="Kits - Kits Page"
    />
  </div>
</template>
